import { render } from "./Force.vue?vue&type=template&id=c0b7c3fe"
import script from "./Force.vue?vue&type=script&lang=js"
export * from "./Force.vue?vue&type=script&lang=js"

import "./Force.vue?vue&type=style&index=0&id=c0b7c3fe&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__